import { isEmpty } from 'bold-ui'
import { SimNaoEnum } from 'components/form'
import { MChatPerguntaEnum, MChatRiscoEnum } from 'graphql/types.generated'
import { FieldMetaState } from 'react-final-form'

import {
  ConsultaSeguimentoAplicacaoModel,
  ConsultaSeguimentoOutroFieldModel,
  ConsultaSeguimentoResultadoEnum,
  PassouFalhouEnum,
} from './model-consultaSeguimento'

export function calculateResultadoConsultaSeguimento(
  aplicacao: ConsultaSeguimentoAplicacaoModel
): ConsultaSeguimentoResultadoEnum {
  let resultado: ConsultaSeguimentoResultadoEnum
  const values = Object.values(aplicacao)
  const perguntasFalhou = values.filter((value) => value.resultado === PassouFalhouEnum.FALHOU)

  if (perguntasFalhou.length >= 2) {
    resultado = ConsultaSeguimentoResultadoEnum.RASTREAMENTO_POSITIVO
  } else {
    resultado = ConsultaSeguimentoResultadoEnum.RASTREAMENTO_NEGATIVO
  }

  return resultado
}

export function getPerguntasSelecionadasFieldHasError(
  meta: Pick<FieldMetaState<MChatPerguntaEnum[]>, 'error' | 'touched'>,
  isMChatRiscoBaixo: boolean
): boolean {
  const { error, touched } = meta

  const hasErrorFromForm = !isEmpty(error) && touched
  const hasErrorFromMChat = !isEmpty(error) && isMChatRiscoBaixo
  const hasError = hasErrorFromForm || hasErrorFromMChat

  return hasError
}

export function getModalFooterCounterText(numberOfPerguntasSelecionadas: number, hasError: boolean): string {
  const hasPerguntasSelecionadas = numberOfPerguntasSelecionadas > 0

  const filledText = numberOfPerguntasSelecionadas === 1 ? 'pergunta selecionada' : 'perguntas selecionadas'
  const emptyText = 'Nenhuma pergunta selecionada'

  const emptyErrorText = `${emptyText}. Selecione mais perguntas.`
  const filledErrorText = `${filledText}. Selecione mais perguntas.`

  const validatedFilledText = hasError ? filledErrorText : filledText
  const validatedEmptyText = hasError ? emptyErrorText : emptyText

  return hasPerguntasSelecionadas ? validatedFilledText : validatedEmptyText
}

export const hasAnyNao = <T extends string>(value: Record<T, SimNaoEnum>): boolean => {
  if (isEmpty(value)) return false
  return Object.values(value).some((item) => item === SimNaoEnum.NAO)
}

export const hasAnySim = <T extends string>(value: Record<T, SimNaoEnum>): boolean => {
  if (isEmpty(value)) return false
  return Object.values(value).some((item) => item === SimNaoEnum.SIM)
}

export const isAllNao = <T extends string>(value: Record<T, SimNaoEnum>, expected: T[]): boolean => {
  if (!value || !expected || isEmpty(expected)) return false

  return expected.every((campo) => value[campo] === SimNaoEnum.NAO)
}

export const isAllSim = <T extends string>(value: Record<T, SimNaoEnum>, expected: T[]): boolean => {
  if (!value || !expected || isEmpty(expected)) return false

  return expected.every((campo) => value[campo] === SimNaoEnum.SIM)
}

export const isAllFilled = <T extends string>(value: Record<T, SimNaoEnum>, expected: T[]): boolean => {
  if (!value || !expected || isEmpty(expected)) return false

  return expected.every((campo) => value[campo] === SimNaoEnum.NAO || value[campo] === SimNaoEnum.SIM)
}

export const isPerguntaOutroFilled = (value: ConsultaSeguimentoOutroFieldModel): boolean => {
  return !isEmpty(value?.textValue)
}

export const isPerguntaOutroSelected = (value: ConsultaSeguimentoOutroFieldModel): boolean => {
  return !isEmpty(value?.radioValue)
}

export const isPerguntaOutroSim = (value: ConsultaSeguimentoOutroFieldModel): boolean => {
  return !isEmpty(value?.textValue) && value?.radioValue === SimNaoEnum.SIM
}

export const isPerguntaOutroNao = (value: ConsultaSeguimentoOutroFieldModel): boolean => {
  return !isEmpty(value?.textValue) && value?.radioValue === SimNaoEnum.NAO
}

export function getMChatForConsultaSeguimento(
  mChatAtualRisco: MChatRiscoEnum,
  mChatAnteriorRisco: MChatRiscoEnum,
  mChatAtualPerguntasFalhas: MChatPerguntaEnum[],
  mChatAnteriorPerguntasFalhas: MChatPerguntaEnum[]
): {
  risco: MChatRiscoEnum
  perguntasFalhas: MChatPerguntaEnum[]
} {
  if (!isEmpty(mChatAtualRisco)) {
    return {
      risco: mChatAtualRisco,
      perguntasFalhas: mChatAtualPerguntasFalhas,
    }
  }
  return {
    risco: mChatAnteriorRisco,
    perguntasFalhas: mChatAnteriorPerguntasFalhas,
  }
}
